import { render } from "./SpeeddialView.vue?vue&type=template&id=735e1d29"
import script from "./SpeeddialView.vue?vue&type=script&lang=js"
export * from "./SpeeddialView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__